import * as React from 'react'

import { KEY_POSITIONS } from './constants'
import Sketch from './Sketch'

const getSketch = (width: number, height: number) => (p: any) => {
  const pointsPerAxis = 10
  const offsetX = width / pointsPerAxis / 2
  const offsetY = height / pointsPerAxis / 2
  const effectSizeInAxisPoints = 2

  p.setup = () => {
    p.createCanvas(width, height)
    for (let x = offsetX; x < width; x += width / pointsPerAxis) {
      for (let y = offsetY; y < height; y += height / pointsPerAxis) {
        p.ellipse(x, y, 10, 10)
      }
    }
  }

  // Lower is faster
  const disappearanceRate = 1

  p.draw = () => {
    const frameRate = p.frameRate()
    const alpha = frameRate ? 255 / frameRate / disappearanceRate : 1
    p.background(0, 0, 0, alpha)
  }

  p.keyPressed = () => {
    const position = KEY_POSITIONS[p.key.toLowerCase()]
    if (position) {
      for (let x = offsetX; x < width; x += width / pointsPerAxis) {
        if (x < (position.x * width - (effectSizeInAxisPoints / 2) * (width / pointsPerAxis))) {
          continue
        }
        if (x > (position.x * width + (effectSizeInAxisPoints / 2) * (width / pointsPerAxis))) {
          continue
        }
        for (let y = offsetY; y < height; y += height / pointsPerAxis) {
          if (y < (position.y * height - (effectSizeInAxisPoints / 2) * (height / pointsPerAxis))) {
            continue
          }
          if (y > (position.y * height + (effectSizeInAxisPoints / 2) * (height / pointsPerAxis))) {
            continue
          }
          p.ellipse(x, y, 10, 10)
        }
      }
    }
  }
}

const Grid = () => <Sketch getSketch={getSketch} />

export default Grid



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Grid.tsx